"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const animals = [
    "baboon",
    "badger",
    "bear",
    "bird",
    "bobcat",
    "bulldog",
    "bullfrog",
    "cat",
    "cheetah",
    "chicken",
    "chipmunk",
    "cobra",
    "cougar",
    "deer",
    "bunny",
    "dodo",
    "dog",
    "dolphin",
    "donkey",
    "dragon",
    "duck",
    "eagle",
    "elephant",
    "falcon",
    "firefox",
    "fish",
    "fox",
    "frog",
    "gecko",
    "goat",
    "goose",
    "horse",
    "hound",
    "husky",
    "impala",
    "kangaroo",
    "ladybug",
    "liger",
    "lion",
    "lionfish",
    "lizard",
    "mole",
    "monkey",
    "moose",
    "mule",
    "octopus",
    "otter",
    "owl",
    "panda",
    "panther",
    "parrot",
    "penguin",
    "giraffe",
    "poodle",
    "puma",
    "labrador",
    "pug",
    "rabbit",
    "robin",
    "seahorse",
    "puppy",
    "kitten",
    "sheep",
    "shrimp",
    "sloth",
    "squid",
    "starfish",
    "stingray",
    "swan",
    "tiger",
    "treefrog",
    "turkey",
    "turtle",
    "walrus",
    "warthog",
    "wolverine",
    "wombat",
    "zebra",
];
exports.default = animals;
//# sourceMappingURL=animals.js.map